"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableColumnsAdditionalProperty = exports.resultsTableColumnsAdditionalPropertyDefinition = void 0;
exports.resultsTableColumnsAdditionalPropertyDefinition = {
    view: { label: 'Results Table Columns Additional' },
    constraints: [
        {
            name: 'properties',
            argument: ['results-table-column-additional'],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'results-table-columns-additional',
};
const isResultsTableColumnsAdditionalProperty = (prop) => {
    return prop.name === exports.resultsTableColumnsAdditionalPropertyDefinition.name;
};
exports.isResultsTableColumnsAdditionalProperty = isResultsTableColumnsAdditionalProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jb2x1bW5zLWFkZGl0aW9uYWwucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9yZXN1bHRzLXRhYmxlLWNvbHVtbnMtYWRkaXRpb25hbC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLCtDQUErQyxHQUFHO0lBQzdELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxrQ0FBa0MsRUFBRTtJQUNuRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxZQUFZO1lBQ2xCLFFBQVEsRUFBRSxDQUFDLGlDQUFpQyxDQUFDO1NBQzlDO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsV0FBVztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxrQ0FBa0M7Q0FDVCxDQUFBO0FBSTFCLE1BQU0sdUNBQXVDLEdBQUcsQ0FBQyxJQUFrQixFQUFpRCxFQUFFO0lBQzNILE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx1REFBK0MsQ0FBQyxJQUFJLENBQUE7QUFDM0UsQ0FBQyxDQUFBO0FBRlksUUFBQSx1Q0FBdUMsMkNBRW5EIn0=